<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" role="doc-part">
<h1 class="h1p"><span aria-label="page 6" epub:type="pagebreak" id="page_6" role="doc-pagebreak"><span aria-label="page 7" epub:type="pagebreak" id="page_7" role="doc-pagebreak">36 HOURS EARLIER…</span></span></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?1767a7dc